export interface StatisticalAnalysisSidebarCheckboxModel {
    [key: string]: boolean
}

export interface StatisticalAnalysisSidebarCheckboxDynamicLabels {
    active: boolean
    fnToExecute: Function
}

export interface StatisticalAnalysisSidebarCheckboxState {
    label: string
    active: boolean
}
export const initialStatisticalAnalysisSidebarCheckboxState =
    (): StatisticalAnalysisSidebarCheckboxState => ({
        active: false,
        label: ''
    })
